import React from "react";
import help from "help/viewSubscriberQuotas.md";
import FilteringControls from "./FilteringControls";
import Report from "./Report";
import Actions from "./Actions";
import AdvancedSettings from "./AdvancedSettings";
import View from "common/View";

export const applyParams = (child, params = {}) =>
  React.isValidElement(child) ? React.cloneElement(child, params) : child;

const Subscribers = ({ subnet, returnView }) => (
  <View title="Subscriber Quotas"
    mdHelp={help}
    returnView = {returnView}
  >
    <Actions />
    <AdvancedSettings />
    <FilteringControls subnet={subnet}>
      {(settings) => <Report {...settings} />}
    </FilteringControls>
  </View>
);

export default Subscribers;
